var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'theme_' + _vm.theme,style:({
  '--font': _vm.isApple
    ? "'Myriad', 'Bogle', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'"
    : 'Myriad',
  '--btnColor': 'linear-gradient(91deg, #3383E5 0%, #1154C7 99%)',
  '--nav-background':'#144AC6',
  '--newbtnColor':'linear-gradient(91deg, #3383E5 0%, #1154C7 99%)',
  '--bgImg':("url(" + (_vm.$img('/bg.png?v=1.04')) + ")"),
  '--userBg':("url(" + (_vm.$img('/user_bgs.png?v=1.04')) + ")")
  // '--bgImg':`url(${bgImage})`,
  // '--userBg':`url(${userBg})`
}),attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }